import styled, { RuleSet } from "styled-components";

/**
 * Mostly necessary to target Spor components
 */
export const StyleTarget = styled.div<{
  $style: RuleSet<Object>;
  $target: string;
}>`
  ${({ $target }) => $target} {
    ${({ $style }) => $style}
  }
`;
